import { Chip, Stack, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { MakeoverQuality, getCreativeCoinCost } from "../../../@types/sharedSchema";

const QUALITY_OPTIONS: { key: MakeoverQuality; labelKey: string; labelDefault: string }[] = [
  { key: "1K", labelKey: "creativesGenerator.quality.standard", labelDefault: "רגיל (1K)" },
  { key: "2K", labelKey: "creativesGenerator.quality.high", labelDefault: "רזולוציה גבוהה (2K)" }
];

/**
 * Quality (resolution) picker for the creatives generator — the model is fixed, so the
 * customer only chooses quality, and the per-image token price scales with it. Small chips,
 * dimmed when not selected.
 */
export default function CreativeQualitySelector({
  quality,
  onChange
}: {
  quality: MakeoverQuality;
  onChange: (q: MakeoverQuality) => void;
}): JSX.Element {
  const { t } = useTranslation();
  return (
    <Stack gap={0.5}>
      <Typography variant="caption" color="text.secondary">
        {t("creativesGenerator.quality.title", "איכות")}
      </Typography>
      <Stack direction="row" gap={1} flexWrap="wrap">
        {QUALITY_OPTIONS.map((opt) => {
          const selected = opt.key === quality;
          return (
            <Chip
              key={opt.key}
              size="small"
              clickable
              color="default"
              variant={selected ? "filled" : "outlined"}
              onClick={() => onChange(opt.key)}
              label={`${t(opt.labelKey, opt.labelDefault)} · ${getCreativeCoinCost(opt.key)} 🪙`}
              sx={{
                opacity: selected ? 1 : 0.5,
                ...(selected && {
                  backgroundColor: "#C8E6C9", // pastel green
                  color: "#1B5E20",
                  "&:hover": { backgroundColor: "#B6DEB8" }
                })
              }}
            />
          );
        })}
      </Stack>
    </Stack>
  );
}
